// Imagen de reserva para productos y ofertas sin foto.
//
// Es la mascota de CholloMan, no un marcador de posición genérico: una card sin
// foto sigue pareciendo parte del sitio en vez de un hueco. Antes de esto hubo
// dos intentos peores:
//
//   1. `https://via.placeholder.com/300x300`, que dejó de responder —así que el
//      marcador de posición pasó a ser una imagen rota, justo lo que venía a
//      evitar— y además costaba una petición a un tercero por card.
//   2. Un SVG embebido que decía «Sin imagen». No fallaba, pero se leía como un
//      error del sitio.
//
// El archivo se sirve desde `public/`, o sea del mismo origen: no depende de
// nadie y el navegador lo cachea una vez para todas las cards.
export const IMAGEN_SIN_FOTO = '/img/default-product.jpg';

/**
 * Devuelve la URL de la imagen del producto, o el marcador de posición si no
 * hay ninguna utilizable.
 *
 * @param {string} url        lo que traiga el registro
 * @param {boolean} falló     si esa URL ya dio error al cargar
 */
export const imagenDeProducto = (url, falló = false) =>
  (!falló && url && String(url).trim()) ? url : IMAGEN_SIN_FOTO;
